import type {
  DiagnosisUnlockCtaConfig,
  DiagnosisUnlockTopNavConfig,
} from "./types";

const ADVANCE_TO_STEP3_ACTION = "advance_to_step3";

/**
 * step2 主按钮：
 * - 无 `onClick` → 默认进 step3
 * - 有 `onClick` 且 action 为 `advance_to_step3` → 先 `onClick`，再 resolve 关窗
 * - 有 `onClick` 且 action 非 `advance_to_step3` → 先 `onClick`，再进 step3
 */
export async function runStep2PrimaryCta(
  cta: DiagnosisUnlockCtaConfig,
  advanceToStep3: () => void,
  finish: (action: string) => void,
): Promise<void> {
  const hasOnClick = typeof cta.onClick === "function";
  if (hasOnClick) {
    await cta.onClick?.();
    if (cta.action === ADVANCE_TO_STEP3_ACTION) {
      finish(cta.action);
      return;
    }
  }
  advanceToStep3();
}

/** step3 底栏：先 onClick，再关窗 resolve action */
export async function runStep3TerminalCta(
  cta: DiagnosisUnlockCtaConfig,
  finish: (action: string) => void,
): Promise<void> {
  await cta.onClick?.();
  finish(cta.action);
}

/** 顶栏 close dismiss：先 onClick，再关窗 resolve dismissAction */
export async function runTopNavDismiss(
  topNav: Extract<DiagnosisUnlockTopNavConfig, { variant: "close" }>,
  finish: (action: string) => void,
): Promise<void> {
  await topNav.onClick?.();
  finish(topNav.dismissAction);
}
